/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { WarehouseStockResponse } from '../../models/warehouse-stock-response';

export interface WarehouseControllerCalculateAndGetStockByDate$Params {

/**
 * Sends 0 to remove limit
 */
  limit: number;
  skip: number;
  product_id?: number;
  office_id?: number;
  stock_type?: number;
  calculation_date: string;
  query?: string;
  name?: string;
  code_internal?: string;
  code_supplier?: string;
  code_ean?: string;
  brand?: string;
  desc_short?: string;
  part_number?: string;
  cat_id?: number;
  related_order_id?: number;
  hide_zero_stock?: boolean;

/**
 * Se true, la lista comprende anche le sedi di sistema (guasti, RAEE, smarriti), escluse di default
 */
  include_special?: boolean;
}

export function warehouseControllerCalculateAndGetStockByDate(http: HttpClient, rootUrl: string, params: WarehouseControllerCalculateAndGetStockByDate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: WarehouseStockResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, warehouseControllerCalculateAndGetStockByDate.PATH, 'get');
  if (params) {
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
    rb.query('product_id', params.product_id, {});
    rb.query('office_id', params.office_id, {});
    rb.query('stock_type', params.stock_type, {});
    rb.query('calculation_date', params.calculation_date, {});
    rb.query('query', params.query, {});
    rb.query('name', params.name, {});
    rb.query('code_internal', params.code_internal, {});
    rb.query('code_supplier', params.code_supplier, {});
    rb.query('code_ean', params.code_ean, {});
    rb.query('brand', params.brand, {});
    rb.query('desc_short', params.desc_short, {});
    rb.query('part_number', params.part_number, {});
    rb.query('cat_id', params.cat_id, {});
    rb.query('related_order_id', params.related_order_id, {});
    rb.query('hide_zero_stock', params.hide_zero_stock, {});
    rb.query('include_special', params.include_special, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: WarehouseStockResponse;
      }>;
    })
  );
}

warehouseControllerCalculateAndGetStockByDate.PATH = '/warehouse/stock-by-date';
